import SurveyAnswerFormApp from './survey_answer_form_app'

export default {
  SurveyAnswerFormApp
}